var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11C18.5 15.1421 15.1421 18.5 11 18.5C6.85787 18.5 3.5 15.1421 3.5 11C3.5 6.85787 6.85787 3.5 11 3.5C15.1421 3.5 18.5 6.85787 18.5 11Z",
    stroke: "#0E1C36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1464 20.8536C20.3417 21.0488 20.6583 21.0488 20.8536 20.8536C21.0488 20.6583 21.0488 20.3417 20.8536 20.1464L20.1464 20.8536ZM20.8536 20.1464L16.8536 16.1464L16.1464 16.8536L20.1464 20.8536L20.8536 20.1464Z",
    fill: "#0E1C36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch24);
export default __webpack_public_path__ + "static/media/icon-search-24.7e2ce37e8c47596439090355fe22b77f.svg";
export { ForwardRef as ReactComponent };